import { render, staticRenderFns } from "./ClientPackages.vue?vue&type=template&id=a55301c4&scoped=true&"
import script from "./ClientPackages.vue?vue&type=script&lang=js&"
export * from "./ClientPackages.vue?vue&type=script&lang=js&"
import style0 from "./ClientPackages.vue?vue&type=style&index=0&id=a55301c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55301c4",
  null
  
)

export default component.exports